// ** React Imports
import { useState } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import LocationAutocomplete from "components/layout/LocationAutocomplete";
import Text from "components/typography/Text";
import { UserpanelRow } from "containers/Userpanel/components/UserpanelRow";

// ** Styles

// #####################################################

const Location = ({ onAccept, isBan }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	// ** Dane lokalizacyjne z profilu zalogowanego użytkownika
	const userLocationSelector = useSelector((state) => ({
		isLoaded: Boolean(state?.globalUser?.id),
		country: state?.globalUser?.country,
		regionName: state?.globalUser?.regionName,
		cityName: state?.globalUser?.cityName,
		url: state?.globalUser?.urlSearch,
	}));

	const userLocationData = userLocationSelector;

	const [selected, setSelected] = useState(
		userLocationData?.isLoaded
			? { ...userLocationData, distance: 50 }
			: null
	);

	const isModerated = useSelector(
		(state) => state.globalUser.acceptedFields?.city
	);

	return (
		<UserpanelRow toModerate={!isModerated}>
			<LocationAutocomplete
				location={selected}
				onAccept={(data) => {
					onAccept({
						city: data?.cityId,
						region: data?.regionId,
						country: data?.country,
						location: data,
					});
					setSelected(data);
				}}
				label={t("filtersAndSelectors:locationLabel")}
				withLabel
				onlyCities
				noPad
				noMaxWidth
				isBan={isBan}
				withGeolocation
				activatorOptions={{ withGeolocation: true }}
				notCleanInputInUseEffect={true}
			/>
			{isModerated ? null : (
				<Text textBreak small color="grey">
					{t("userpanel:waitingForModerate.common")}
				</Text>
			)}
		</UserpanelRow>
	);
};

// #####################################################

export default Location;

// #####################################################
